import React from 'react';

import NotificationContext from './NotificationContext';

const withNotifications = WrappedComponent => props => (
    <NotificationContext.Consumer>
        {state => <WrappedComponent {...props} context={state} />}
    </NotificationContext.Consumer>
);

export default withNotifications;
